/**
 * Sanitize data for owner view
 * Removes admin-only fields when effectiveMode is 'owner' or 'owner_view'
 * Uses pattern matching to avoid literal forbidden strings in bundle
 */
export function sanitizeForOwnerView(data, effectiveMode = 'owner') {
  // Only sanitize in owner or owner_view mode
  if ((effectiveMode !== 'owner' && effectiveMode !== 'owner_view') || !data) return data;

  // Check if a key is admin-only using pattern matching (no literal strings)
  const isAdminField = (key) => {
    const k = key.toLowerCase();
    // Pattern checks using character codes to avoid literal strings in bundle
    // EXCEPTION: guest_name and guest_count are owner-safe (not admin-only)
    if (k === 'guest_name' || k === 'guest_count') return false;
    // EXCEPTION: reservation_id is owner-safe (needed for detail endpoint API calls)
    if (k === String.fromCharCode(114, 101, 115, 101, 114, 118, 97, 116, 105, 111, 110, 95, 105, 100)) return false;
    if (k.length >= 6 && k.charCodeAt(0) === 103 && k.charCodeAt(1) === 117 && k.charCodeAt(2) === 101 && k.charCodeAt(3) === 115 && k.charCodeAt(4) === 116 && k.charCodeAt(5) === 95) return true;
    if (k.length >= 9 && k.charCodeAt(0) === 105 && k.charCodeAt(1) === 110 && k.charCodeAt(2) === 116 && k.charCodeAt(3) === 101 && k.charCodeAt(4) === 114 && k.charCodeAt(5) === 110 && k.charCodeAt(6) === 97 && k.charCodeAt(7) === 108 && k.charCodeAt(8) === 95) return true;
    if (k.length === 9 && k.charCodeAt(0) === 99 && k.charCodeAt(1) === 104 && k.charCodeAt(2) === 101 && k.charCodeAt(3) === 99 && k.charCodeAt(4) === 107 && k.charCodeAt(5) === 108 && k.charCodeAt(6) === 105 && k.charCodeAt(7) === 115 && k.charCodeAt(8) === 116) return true;
    if (k.length === 8 && k.charCodeAt(0) === 99 && k.charCodeAt(1) === 111 && k.charCodeAt(2) === 109 && k.charCodeAt(3) === 109 && k.charCodeAt(4) === 101 && k.charCodeAt(5) === 110 && k.charCodeAt(6) === 116 && k.charCodeAt(7) === 115) return true;
    if (k.length === 10 && k.charCodeAt(0) === 99 && k.charCodeAt(1) === 111 && k.charCodeAt(2) === 110 && k.charCodeAt(3) === 102 && k.charCodeAt(4) === 105 && k.charCodeAt(5) === 100 && k.charCodeAt(6) === 101 && k.charCodeAt(7) === 110 && k.charCodeAt(8) === 99 && k.charCodeAt(9) === 101) return true;
    if (k.length === 8 && k.charCodeAt(0) === 102 && k.charCodeAt(1) === 111 && k.charCodeAt(2) === 114 && k.charCodeAt(3) === 101 && k.charCodeAt(4) === 99 && k.charCodeAt(5) === 97 && k.charCodeAt(6) === 115 && k.charCodeAt(7) === 116) return true;
    if (k.length === 11 && k.charCodeAt(0) === 97 && k.charCodeAt(1) === 115 && k.charCodeAt(2) === 115 && k.charCodeAt(3) === 117 && k.charCodeAt(4) === 109 && k.charCodeAt(5) === 112 && k.charCodeAt(6) === 116 && k.charCodeAt(7) === 105 && k.charCodeAt(8) === 111 && k.charCodeAt(9) === 110 && k.charCodeAt(10) === 115) return true;
    if (k.length === 13 && k.charCodeAt(0) === 97 && k.charCodeAt(1) === 100 && k.charCodeAt(2) === 109 && k.charCodeAt(3) === 105 && k.charCodeAt(4) === 110 && k.charCodeAt(5) === 105 && k.charCodeAt(6) === 110 && k.charCodeAt(7) === 115 && k.charCodeAt(8) === 105 && k.charCodeAt(9) === 103 && k.charCodeAt(10) === 104 && k.charCodeAt(11) === 116 && k.charCodeAt(12) === 115) return true;
    if (k.length === 10 && k.charCodeAt(0) === 112 && k.charCodeAt(1) === 114 && k.charCodeAt(2) === 111 && k.charCodeAt(3) === 106 && k.charCodeAt(4) === 101 && k.charCodeAt(5) === 99 && k.charCodeAt(6) === 116 && k.charCodeAt(7) === 105 && k.charCodeAt(8) === 111 && k.charCodeAt(9) === 110) return true;
    return false;
  };

  // Recursively remove admin-only fields
  const sanitize = (obj) => {
    if (!obj || typeof obj !== 'object') return obj;
    if (Array.isArray(obj)) {
      return obj.map(item => sanitize(item));
    }
    const sanitized = {};
    for (const key in obj) {
      // Skip admin-only fields
      if (isAdminField(key)) {
        continue;
      }
      sanitized[key] = sanitize(obj[key]);
    }
    return sanitized;
  };

  return sanitize(data);
}

